export default __webpack_public_path__ + "static/media/tavi_main_mobile@2x.d3b915fa.jpg";